var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 22,
    viewBox: "0 0 385 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.2689C58.0997 6.85345 211.047 -10.5281 382.039 19.2689",
    stroke: "url(#paint0_linear_405_19502)",
    strokeWidth: 5.06229,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_19502",
    x1: 3,
    y1: 11.0426,
    x2: 382.039,
    y2: 11.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275745",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImgUnderline);
export default __webpack_public_path__ + "static/media/login_img_underline.59a9aca49cffccafab6577448ef18ac4.svg";
export { ForwardRef as ReactComponent };